export function formatTimestamp(timestamp, locale = "en-US", options = {}) {
  if (!timestamp) {
    return "N/A";
  }

  let date;
  
  // Handle different timestamp formats
  if (typeof timestamp === "number") {
    date = new Date(timestamp);
  } else if (typeof timestamp === "string") {
    date = new Date(timestamp);
  } else {
    return "Invalid Date";
  }

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  const defaultOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  return date.toLocaleString(locale, { ...defaultOptions, ...options });
}
